import { checkbox } from './component/checkbox/checkbox.js'
import { select } from './component/select/select.js'
import { spinner } from './component/spiner/spiner.js'
import { slider } from './component/slider/slider.js'
import { header } from './component/header/header.js'
import { popup } from './component/popup/popup.js'
var smoothScroll = require('smooth-scroll')


$( document ).ready(function () {
    slider()
    smoothScroll.init({
        offset: 120,
        updateURL: false
    });
    checkbox()
    header()
    select()
    spinner()
    popup()
})



/** WEBPACK FOOTER **
 ** ./assets/app/app.js
 **/